<script>
  import Container from "./Container.svelte";
  export let name;
</script>

<Container>
  <h4 class="text-base text-center pt-2">name</h4>
  <input
    aria-label="Workout name"
    bind:value={name}
    class="focus:ring-4 ring-gray-500 focus:outline-none ring-opacity-30 font-semibold p-2 bg-gray-600 border-0 rounded-xl w-full mt-5"
    placeholder="name e.g &quot;Jump Rope&quot;"
  />
</Container>
